import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  minWidth: theme.spacing(100),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.contrast,
  boxShadow: '0px 0px 8px 0px rgba(145, 120, 120, 0.15)',
}));

export const ProgramItemContainer = styled(Paper)<{ isCurrent?: boolean }>(
  ({ theme, isCurrent }) => ({
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    minWidth: 250,
    borderRadius: theme.spacing(2),
    backgroundColor: isCurrent
      ? theme.palette.background.default
      : theme.palette.background.contrast,
    opacity: 1,
    border: '1px solid transparent',
    transition: theme.transitions.create(
      ['background-color', 'box-shadow', 'opacity', 'border-color'],
      {
        duration: theme.transitions.duration.standard,
      },
    ),

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.background.default,
      boxShadow: '0px 0px 8px 0px rgba(145, 120, 120, 0.15)',
      opacity: 1,
    },
  }),
);

export const ProgramListContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  opacity: 1,
  '& *': {
    opacity: '1 !important',
  },
}));

export const ProgramListItem = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  opacity: 1,
  '& *': {
    opacity: '1 !important',
  },
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  minHeight: 200,
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',

  '& .error-message': {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
}));
